<!-- Desktop Sidebar Navigation (hidden on mobile) -->
<nav class="desktop-sidebar">
  <div class="sidebar-content">
    <!-- Logo -->
    <div class="sidebar-logo">
      <ion-text class="ss-logo">{{ appName }}</ion-text>
    </div>

    <!-- Main Navigation -->
    <div class="sidebar-nav">
      <button
        class="nav-item"
        [class.active]="activeSection === 'business-info'"
        (click)="navigateToTab('business-info')"
        >
        <ion-icon [src]="activeSection === 'business-info' ? '/assets/ic-trend.svg' : '/assets/ic-trend-outline.svg'"></ion-icon>
        <span>Dashboard</span>
      </button>

      <button
        class="nav-item"
        [class.active]="activeSection === 'shopify-management'"
        (click)="navigateToTab('shopify-management')"
        >
        <ion-icon [src]="activeSection === 'shopify-management' ? '/assets/ic-bag.svg' : '/assets/ic-bag-outline.svg'"></ion-icon>
        <span>Shopify</span>
      </button>

      <button
        class="nav-item"
        [class.active]="activeSection === 'donate'"
        (click)="navigateToTab('donate')"
        >
        <ion-icon [name]="activeSection === 'donate' ? 'heart' : 'heart-outline'"></ion-icon>
        <span>Donate</span>
      </button>

      <button
        class="nav-item"
        [class.active]="activeSection === 'social-content'"
        (click)="navigateToTab('social-content')"
        >
        <ion-icon [src]="activeSection === 'social-content' ? '/assets/ic-feed.svg' : '/assets/ic-feed-outline.svg'"></ion-icon>
        <span>Social</span>
      </button>

      <button
        class="nav-item"
        [class.active]="activeSection === 'items'"
        (click)="navigateToTab('items')"
        >
        <ion-icon [src]="activeSection === 'items' ? '/assets/ic-shirt.svg' : '/assets/ic-shirt-outline.svg'"></ion-icon>
        <span>Items</span>
      </button>
    </div>

    <div class="sidebar-bottom">
      <button class="sidebar-action-btn switch-btn" (click)="sidebarSwitchToUser()">
        <ion-icon name="swap-horizontal-outline"></ion-icon>
        <span>User Portal</span>
      </button>
      <button class="sidebar-action-btn logout-btn" (click)="sidebarSignOut()">
        <ion-icon name="log-out-outline"></ion-icon>
        <span>Log Out</span>
      </button>
    </div>
  </div>
</nav>

<!-- Desktop Header (separate from mobile, hidden on mobile) -->
<header class="desktop-header">
  <div class="header-start">
    @if (!isMainPage) {
      <button class="header-back-btn" (click)="back()" aria-label="Go back">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>
    }
    @if (pageTitle) {
      <h2 [class]="pageTitleClass">{{ pageTitle }}</h2>
    }
  </div>
  <div class="header-end">
    <button
      class="header-icon-btn notification-btn"
      (click)="goToNotifications()"
      aria-label="Notifications"
      >
      <ion-icon name="notifications-outline"></ion-icon>
      @if (notificationCount > 0) {
        <span class="notification-badge">
          {{ notificationCount > 99 ? '99+' : notificationCount }}
        </span>
      }
    </button>
    <button
      class="header-icon-btn discover-btn"
      (click)="goToDiscover()"
      aria-label="Discover"
      >
      <ion-icon name="search-outline"></ion-icon>
    </button>
    @if (currentTab === 'donate') {
      <button
        class="header-icon-btn donation-history-btn"
        (click)="goToDonationHistory()"
        aria-label="Donation history"
        >
        <ion-icon name="time-outline"></ion-icon>
      </button>
    }
    @if (currentTab === 'donate') {
      <button
        class="header-icon-btn donation-schedule-btn"
        (click)="goToRecurringDonations()"
        aria-label="Donation schedule"
        >
        <ion-icon name="calendar-outline"></ion-icon>
      </button>
    }
    <button
      class="header-avatar-btn"
      (click)="openMenu()"
      aria-label="Menu"
      >
      <div class="avatar-wrapper" [class.has-avatar]="business?.avatarUrl">
        <ion-img
          [src]="business?.avatarUrl || 'assets/ic-business.svg'"
          alt="Profile"
        ></ion-img>
      </div>
    </button>
  </div>
</header>

<!-- Mobile Header (hidden on desktop) -->
<ion-header class="ion-no-border mobile-header">
  <ion-toolbar class="main-toolbar">
    <ion-buttons slot="start">
      @if (!isMainPage) {
        <ion-button class="btn-back" (click)="back()">
          <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
        </ion-button>
      }
      @if (!pageTitle) {
        <ion-text class="ss-logo">{{ appName }}</ion-text>
      }
      @if (pageTitle) {
        <div class="page-title">
          <h2 [class]="pageTitleClass">{{ pageTitle }}</h2>
        </div>
      }
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="goToNotifications()" class="btn-ic-notification" fill="clear">
        <ion-icon name="notifications"></ion-icon>
        @if (notificationCount > 0) {
          <ion-badge color="danger" class="notification-badge">
            {{ notificationCount > 99 ? '99+' : notificationCount }}
          </ion-badge>
        }
      </ion-button>
      <ion-button (click)="goToDiscover()" class="btn-ic-discover" fill="clear" aria-label="Discover">
        <ion-icon slot="icon-only" name="search-outline"></ion-icon>
      </ion-button>
      @if (currentTab === 'donate') {
        <ion-button
          (click)="goToDonationHistory()"
          class="btn-ic-history"
          fill="clear"
          aria-label="Donation history"
          >
          <ion-icon slot="icon-only" name="time-outline"></ion-icon>
        </ion-button>
      }
      @if (currentTab === 'donate') {
        <ion-button
          (click)="goToRecurringDonations()"
          class="btn-ic-schedule"
          fill="clear"
          aria-label="Donation schedule"
          >
          <ion-icon slot="icon-only" name="calendar-outline"></ion-icon>
        </ion-button>
      }
      <ion-button (click)="openMenu()" fill="clear">
        <div class="logo-container" [class.has-avatar]="business?.avatarUrl">
          @if (!imageLoaded) {
            <ion-skeleton-text animated class="avatar-skeleton"></ion-skeleton-text>
          }
          <ion-img
            [src]="business?.avatarUrl || 'assets/ic-business.svg'"
            [alt]="business?.name + ' logo'"
            (ionImgDidLoad)="onImageLoad()"
            [class.hidden]="!imageLoaded"
            [class.fade-in]="imageLoaded"
          ></ion-img>
        </div>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<!-- Main content area with tabs -->
<div class="main-content-wrapper">
  <ion-tabs (ionTabsWillChange)="handleTabChange($event)">
    <!-- Mobile Tab Bar (hidden on desktop) -->
    <ion-tab-bar slot="bottom" class="mobile-tab-bar">
      <ion-tab-button tab="business-info" [selected]="currentTab === 'business-info'">
        <ion-icon
          [src]="
            currentTab === 'business-info' ? '/assets/ic-trend.svg' : '/assets/ic-trend-outline.svg'
          "
        ></ion-icon>
        <ion-label>Dashboard</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="shopify-management" [selected]="currentTab === 'shopify-management'">
        <ion-icon
          [src]="
            currentTab === 'shopify-management' ? '/assets/ic-bag.svg' : '/assets/ic-bag-outline.svg'
          "
        ></ion-icon>
        <ion-label>Shopify</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="donate" [selected]="currentTab === 'donate'">
        <ion-icon [name]="currentTab === 'donate' ? 'heart' : 'heart-outline'"></ion-icon>
        <ion-label>Donate</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="social-content" [selected]="currentTab === 'social-content'">
        <ion-icon
          [src]="
            currentTab === 'social-content'
              ? '/assets/ic-feed.svg'
              : '/assets/ic-feed-outline.svg'
          "
        ></ion-icon>
        <ion-label>Social</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="items" [selected]="currentTab === 'items'">
        <ion-icon
          [src]="
            currentTab === 'items' ? '/assets/ic-shirt.svg' : '/assets/ic-shirt-outline.svg'
          "
        ></ion-icon>
        <ion-label>Items</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</div>
